import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Volume2 } from "lucide-react";
import { isIOS } from "@/lib/audioPool";

const HINT_KEY = "nex_ios_sound_hint";

// Safety net when a browser blocks sound, plus a one-time iPhone silent-switch hint.
export default function SoundGate({ color = "#D4AF37" }) {
  const [blocked, setBlocked] = useState(false);
  const [hint, setHint] = useState(false);

  useEffect(() => {
    const onBlocked = () => setBlocked(true);
    const onUnlocked = () => setBlocked(false);
    window.addEventListener("nex-audio-blocked", onBlocked);
    window.addEventListener("nex-audio-unlocked", onUnlocked);
    return () => {
      window.removeEventListener("nex-audio-blocked", onBlocked);
      window.removeEventListener("nex-audio-unlocked", onUnlocked);
    };
  }, []);

  useEffect(() => {
    if (!isIOS) return undefined;
    try { if (sessionStorage.getItem(HINT_KEY)) return undefined; sessionStorage.setItem(HINT_KEY, "1"); } catch {}
    setHint(true);
    const t = setTimeout(() => setHint(false), 7000);
    return () => clearTimeout(t);
  }, []);

  return (
    <AnimatePresence>
      {blocked && (
        <motion.div key="gate" className="fixed inset-0 z-[150] flex items-center justify-center bg-black/50 backdrop-blur-sm"
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
          <motion.button type="button" data-testid="sound-gate-button" onClick={() => setBlocked(false)}
            className="inline-flex items-center gap-3 rounded-full px-9 py-4 text-lg font-extrabold text-[#0A0612] active:scale-95 transition-transform"
            style={{ background: color }}
            animate={{ boxShadow: [`0 0 0 0 ${color}aa`, `0 0 0 22px ${color}00`] }} transition={{ duration: 1.6, repeat: Infinity }}>
            <Volume2 className="w-6 h-6" /> Tap for sound
          </motion.button>
        </motion.div>
      )}
      {hint && !blocked && (
        <motion.div key="hint" data-testid="sound-ios-hint" onClick={() => setHint(false)}
          className="fixed top-3 left-1/2 -translate-x-1/2 z-[150] inline-flex items-center gap-2 rounded-full border border-white/15 bg-black/80 backdrop-blur-md px-4 py-2 text-xs text-white"
          initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }}>
          <Volume2 className="w-3.5 h-3.5" style={{ color }} /> Sound on? Check your silent switch &amp; volume
        </motion.div>
      )}
    </AnimatePresence>
  );
}
